import { useState } from "react";
import { toast } from "sonner";

const LINKS = [
    { label: "About", href: "#about", testid: "nav-about-link" },
    { label: "Skills", href: "#skills", testid: "nav-skills-link" },
    { label: "Projects", href: "#projects", testid: "nav-projects-link" },
    { label: "Contact", href: "#contact", testid: "nav-contact-link" },
];

export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <g stroke="#6F4E37" strokeWidth="3" fill="none" strokeLinecap="round">
            <path d="M16 26 h26 v14 a10 10 0 0 1 -10 10 h-6 a10 10 0 0 1 -10 -10 z" />
            <path d="M42 29 h4 a5 5 0 0 1 0 10 h-4" />
        </g>
        <g className="steam" stroke="#6F4E37" strokeWidth="2.4" fill="none" strokeLinecap="round">
            <path d="M23 20 c0 -3 3 -3 3 -6" />
            <path d="M30 20 c0 -3 3 -3 3 -6" />
        </g>
    </svg>
);

export const Navbar = () => {
    const [caffeine, setCaffeine] = useState(98);
    const go = (e, href) => {
        e.preventDefault();
        const target = document.querySelector(href);
        if (window.__lenis && target) window.__lenis.scrollTo(target, { offset: -60 });
        else target?.scrollIntoView({ behavior: "smooth" });
    };
    const refill = () => {
        setCaffeine(100);
        toast.success("Cup refilled. Caffeine levels critical-to-optimal.");
        setTimeout(() => setCaffeine(98), 4000);
    };
    return (
        <header
            data-testid="navbar"
            className="fixed inset-x-0 top-0 z-50 border-b border-coffee/15 bg-paper/85 backdrop-blur-md"
        >
            <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5 sm:px-10">
                <a
                    href="#about"
                    data-testid="nav-logo"
                    onClick={(e) => go(e, "#about")}
                    className="group flex items-center gap-2.5"
                >
                    <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[8deg]" />
                    <span className="font-serif text-lg font-semibold italic tracking-tight text-ink">
                        Yuvraj Singh
                    </span>
                </a>
                <nav className="hidden items-center gap-7 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            onClick={(e) => go(e, l.href)}
                            className="group relative font-mono text-xs uppercase tracking-[0.18em] text-ink/70 transition-colors duration-300 hover:text-coffee-dark"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-coffee transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </nav>
                <button
                    data-testid="caffeine-meter"
                    onClick={refill}
                    title="Click to refill"
                    className="flex items-center gap-2 rounded-full border border-coffee/25 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-coffee transition-colors duration-300 hover:bg-coffee hover:text-paper"
                >
                    <span className="relative flex h-1.5 w-1.5">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" />
                    </span>
                    Caffeine {caffeine}%
                </button>
            </div>
        </header>
    );
};
